import { ConsigneeValue } from "pages/shipper/RequestFormV2/defaults/consigneeDefaults";
import { ScheduleStopValue } from "pages/shipper/RequestFormV2/defaults/scheduleDefaults";
import { DELIVERY_STOP_INDEX, mapDeliveryStopToConsignee } from "@RequestFormV2/sections/Schedule/utils/mapStopToConsignee";

export { DELIVERY_STOP_INDEX };

export function mapDeliveryStopToNotifyParty(stop: ScheduleStopValue) {
  const mapped = mapDeliveryStopToConsignee(stop);
  return {
    ...mapped,
    form_address_contact_type: "delivery" as const,
  };
}

export function mapConsigneeToNotifyParty(consignee: ConsigneeValue) {
  return {
    address_type: consignee.address_type,
    address_id: consignee.address_id,
    address_reference_number: consignee.address_reference_number ?? "",
    address_name: consignee.address_name ?? "",
    address_street: consignee.address_street ?? "",
    address_street_line2: consignee.address_street_line2 ?? "",
    address_city: consignee.address_city ?? "",
    address_state: consignee.address_state ?? "",
    address_country: consignee.address_country ?? "",
    address_zipcode: consignee.address_zipcode ?? "",
    contact_name: consignee.contact_name ?? "",
    contact_phone: consignee.contact_phone ?? "",
    contact_email: consignee.contact_email ?? "",
    airport: consignee.airport ?? "",
    airport_name: consignee.airport_name ?? "",
    seaport: consignee.seaport ?? "",
    seaport_name: consignee.seaport_name ?? "",
    form_address_contact_type: "consignee" as const,
  };
}
